// extracted by mini-css-extract-plugin
export default {"divider":"UyXgtLEuZtNDXLY5zm9Z"};